module.exports = __webpack_public_path__ + "static/photo-dei-expo-5b0b6c1860576c1c41d7fa362472a7b6.jpg";